module.exports = __webpack_public_path__ + "img/headerbanner-mini.a3674e22.jpg";